import React from "react";
import "../Terms/Terms.css"; // ✅ Reuse the same CSS you already have

const ShippingPolicy = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        {/* Header */}
        <div className="terms-header">
          <h1>Shipping Policy</h1>
          <p className="terms-sub">
            At <span className="brand">Shawl Haus</span>, we aim to make
            your shopping experience smooth, reliable, and worry-free. Please
            review our shipping policy below.
          </p>
        </div>

        {/* Cards */}
        <div className="terms-card">
          <h2>📦 Processing Time</h2>
          <ul>
            <li>All orders are processed within 1–3 business days after payment is confirmed.</li>
            <li>Orders placed on weekends or public holidays will be processed on the next business day.</li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🌍 Shipping Options & Delivery Times</h2>
          <ul>
            <li>Domestic Shipping (within [Country]): Estimated delivery time is 3–7 business days.</li>
            <li>International Shipping: Estimated delivery time is 7–21 business days, depending on destination and customs clearance.</li>
            <li>Expedited shipping options may be available at checkout.</li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>💰 Shipping Rates</h2>
          <ul>
            <li>Shipping rates are calculated at checkout based on weight, destination, and selected service.</li>
            <li>Free shipping is offered on domestic orders over $250.</li>
            <li>Delivery/shipping fees are non-refundable, even in the case of returns or exchanges.</li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>📑 Order Tracking</h2>
          <p>
            Once your order has been shipped, you will receive a confirmation
            email with a tracking number to monitor your delivery.
          </p>
        </div>

        <div className="terms-card">
          <h2>🛃 Customs, Duties & Taxes (International Orders)</h2>
          <ul>
            <li>
              International orders may be subject to import duties, customs fees,
              and local taxes, which are the responsibility of the buyer.
            </li>
            <li>
              Any duties or fees incurred on returned items will also be billed
              to the customer.
            </li>
            <li>
              <span className="brand">Shawl Haus</span> is not responsible
              for delays caused by customs clearance.
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>🚚 Delivery Issues</h2>
          <ul>
            <li>
              If your package is delayed, lost, or arrives damaged, please
              contact us at{" "}
              <span className="brand">[support email/phone]</span> within 7 days
              of delivery so we can assist you promptly.
            </li>
            <li>
              We are not responsible for incorrect shipping addresses provided at checkout.
            </li>
          </ul>
        </div>

        <div className="terms-card">
          <h2>❓ Questions</h2>
          <p>
            For any shipping-related inquiries, please reach out to us at{" "}
            <span className="brand">[support email]</span>.
          </p>
        </div>

        {/* Footer */}
        <div className="terms-footer">
          <p>
            &copy; {new Date().getFullYear()}{" "}
            <span className="brand">Shawl Haus</span>. All rights
            reserved.
          </p>
          <p className="small">
            This policy is subject to change without notice. Please review it
            regularly for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
